import cart from "app/reducers/cart";
import notifications from "app/reducers/notifications";
import orders from "app/reducers/orders";
import page from "app/reducers/page";
import stripe from "app/reducers/stripe";
import user from "app/reducers/user";
import Cache from "lib/cache";

const combineReducers = (reducers) => (
  (state, action) => {
    const newState = {};

    Object.keys(reducers).forEach((key) => {
      newState[key] = reducers[key]({action, state: state[key]});
    });

    return newState;
  }
);
const defaultReducer = ({state}) => state;

export const createInitialState = (props) => ({
  app: props.app,
  cart: Cache.get("cart") || {},
  channel: props.channel,
  notifications: props.notifications || [],
  orders: [],
  page: {},
  pages: props.pages,
  sections: props.sections,
  user: props.user
});

export default combineReducers({
  app: defaultReducer,
  cart,
  channel: defaultReducer,
  notifications,
  orders,
  page,
  pages: defaultReducer,
  sections: defaultReducer,
  stripe,
  user
});
